import type { SupabaseClient } from '@supabase/supabase-js';

// En qué punto del ingreso está la persona.
//  entrar: sin sesión · inscribir: con contraseña, falta configurar el código (primera vez)
//  codigo: con contraseña, falta el código de hoy · adentro: verificación en dos pasos completa (aal2)
export type Etapa = 'cargando' | 'sin-configurar' | 'sin-conexion' | 'entrar' | 'inscribir' | 'codigo' | 'adentro';

export async function etapaActual(sb: SupabaseClient): Promise<Etapa> {
  const { data: { session } } = await sb.auth.getSession();
  if (!session) return 'entrar';
  const { data, error } = await sb.auth.mfa.getAuthenticatorAssuranceLevel();
  if (error || !data) return 'sin-conexion';
  if (data.currentLevel === 'aal2') return 'adentro';
  if (data.nextLevel === 'aal2') return 'codigo';
  return 'inscribir';
}

// Mensajes de error en español, sin tecnicismos.
export function mensajeError(e: unknown): string {
  const err = (e || {}) as { code?: string; message?: string; status?: number; name?: string };
  const code = err.code || '';
  const msg = err.message || '';
  if (code === 'invalid_credentials' || /invalid login credentials/i.test(msg)) return 'Correo o contraseña incorrectos.';
  if (code === 'mfa_verification_failed' || /invalid totp|totp code/i.test(msg)) return 'El código no coincide o ya venció. Escribe el que aparece ahora en tu app de códigos.';
  if (code === 'over_request_rate_limit' || err.status === 429) return 'Demasiados intentos seguidos. Espera un minuto y vuelve a intentar.';
  if (code === 'user_banned') return 'Esta cuenta está bloqueada. Avísale a Felipe.';
  if (err.name === 'AuthRetryableFetchError' || /failed to fetch|network/i.test(msg)) return 'No hay conexión con el sistema. Revisa el internet y vuelve a intentar.';
  return 'No se pudo completar. ' + (msg || 'Intenta de nuevo.');
}

export const soloDigitos = (s: string) => s.replace(/\D/g, '').slice(0, 6);
